export const channelSavedSuccess = {
  title: 'Updated',
};
